










import Vue from 'vue'

export default Vue.extend({
  props: ['value'] //default value for v-model
})
